import { Injectable } from '@angular/core';

import { LoadingState } from '@personal-area/global/state';
import { AuthService } from '@personal-area/global/authorization/services';
import { Store } from '@ngrx/store';
import { filter, tap } from 'rxjs';

import * as summaryActions from '../actions/summary';
import * as summarySelectors from '../selectors/summary';
import { SummaryState } from '../reducers/summary';

@Injectable()
export class SummaryVerificationFacade {
  public summary$ = this._store.select(summarySelectors.getSummary).pipe(
    tap(({ loadingState }) => {
      // initial state on login, not logout
      if (
        loadingState === LoadingState.initial &&
        this._authService.isLoggedIn
      ) {
        this._store.dispatch(summaryActions.GetSummary());
      }
    }),
    filter(({ loadingState }) =>
      [LoadingState.loaded, LoadingState.failed].includes(loadingState),
    ),
  );

  constructor(private _store: Store, private _authService: AuthService) {}

  public expireBanner(): void {
    this._store.dispatch(summaryActions.ExpireBanner());
  }

  public mergeStatus(status: Partial<Pick<SummaryState, 'idStatus' | 'basicStatus'>>): void {
    this._store.dispatch(summaryActions.MergeStatus(status));
  }

  public getSummary(): void {
    this._store.dispatch(summaryActions.GetSummary());
  }
}
